import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import HomeIcon from '@components/system/MyIcons/HomeIcon';
// styles
import './BackNavigationStyles.scss';
const HomeNavigation = (props: any): ReactElement => {
  const {navigateTo} = props;
  const {t} = useTranslation();

  const goBack = (): void => {
    if (typeof navigateTo === 'function') {
      navigateTo();
    }
  };
  return (
    <div className="back-navigation-wrapper" onClick={(): void => goBack()}>
      <HomeIcon style={{height: '12px', width: '12px'}} />
      <div className="text-view">{t('PAYMENTS_LOGIN.CARD.HOME')}</div>
    </div>
  );
};
export default HomeNavigation;
